import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Alert_Interface } from 'src/app/Interface/Alert_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private http: HttpClient) { }

  GetRecord(Token: String,startDate: String,endDate: String): Observable<Array<Alert_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Alert?token=" + Token
    + "&startDate=" + startDate
    + "&endDate=" + endDate).pipe(
      map(data => {
        return data as Array<Alert_Interface>
      })
    )
  }

  GetInbox(Token: String, startDate: String, endDate: String): Observable<Array<Alert_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Alert/GetInbox?token=" + Token
    + "&startDate=" + startDate
    + "&endDate=" + endDate).pipe(
      map(data => {
        return data as Array<Alert_Interface>
      })
    )
  }

  GetActive(Token: String): Observable<Array<Alert_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Alert/GetActive?token=" + Token).pipe(
      map(data => {
        return data as Array<Alert_Interface>
      })
    )
  }

  SubmitAlert(id:number,
    message: string, 
    cutomer: boolean, 
    title: String,
    expireDate: String, 
    Token: String,
    chart_id: Array<number>,
    file: Array<string>): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model = {
      id: id,
      title: title,
      cutomer: cutomer,
      message: message,
      create_username: expireDate,
    }

    var body = {
      model: model,
      token: Token,
      files: file,
      chart_id: chart_id
    }


    return this.http.post(environment.BaseUrl + "Daro/Alert/SubmitAlert", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body, Token: String) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Alert/Upload?token=" + Token, body).pipe(
      map(data => {

        return data
      })
    )
  }

  DeleteAlert(id: number, Token: String): Observable<Alert_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Alert/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Alert_Interface
      })
    )

  }

}
